<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M150 163l68 69l14 -14l-69 -68l69 -68l-14 -14l-68 69l-68 -69l-14 14l69 68l-69 68l14 14z"
    />
  </svg>
</template>
